/**
 * Component: Cookie Banner
 * ------------------------------------------------------------------------------
 * Simple component to remove a container on click and disable using cookies.
 *
 * @namespace cookieBanner
 */
import Cookies from 'js-cookie';
import breakpoints from '~/helpers/breakpoints';
import cssClasses from '~/helpers/cssClasses';
import { extendDefaults, on } from '~/helpers/utils';
/**
 * DOM selectors.
 */

const selectors = {
  container: '[js-cookie-banner="container"]',
  close: '[js-cookie-banner="close"]'
};
/**
 * Create a new notification object.
 * @param {Object} config - Configuration.
 */

export default (config => {
  /**
   * Instance default settings.
   */
  const defaults = {
    cookie: {
      namespace: 'cookie-policy',
      value: 'accepted',
      expiry: 7
    }
  };
  /**
   * Instance settings.
   */

  const settings = extendDefaults(defaults, config);
  /**
   * DOM node selectors.
   */

  const nodeSelectors = {
    container: document.querySelector(selectors.container)
  };
  /**
   * Initialise component.
   */

  function init() {
    if (!nodeSelectors.container) {
      return;
    }

    if (Cookies.get(settings.cookie.namespace) === settings.cookie.value) {
      return;
    }

    setInitState();
    setEventListeners();
  }
  /**
   * Set event listeners.
   */


  function setEventListeners() {
    on('click', nodeSelectors.container.querySelector(selectors.close), event => handleCloseEvent(event));
  }
  /**
   * Set init state.
   */


  function setInitState() {
    var _nodeSelectors$contai;

    nodeSelectors.container.classList.add(cssClasses.active);
    const offset = ((_nodeSelectors$contai = nodeSelectors.container) === null || _nodeSelectors$contai === void 0 ? void 0 : _nodeSelectors$contai.offsetHeight) || 0;

    if (window.zE) {
      window.zE('webWidget', 'updateSettings', {
        webWidget: {
          offset: {
            vertical: "".concat(offset, "px"),
            mobile: {
              vertical: "".concat(offset, "px")
            }
          },
          zIndex: 23
        }
      });
    } else {
      window.zESettings = {
        webWidget: {
          offset: {
            vertical: "".concat(offset, "px"),
            mobile: {
              vertical: "".concat(offset, "px")
            }
          },
          zIndex: 23
        }
      };
    }
  }
  /**
   * Handle close event.
   * @param {Event} event - Click event.
   */


  function handleCloseEvent(event) {
    event.preventDefault();
    nodeSelectors.container.classList.remove(cssClasses.active);
    Frame.EventBus.emit('Cookie:accepted');
    Cookies.set(settings.cookie.namespace, settings.cookie.value, {
      expires: settings.cookie.expiry
    }); // Don't reposition Zendesk chat icon on small screens PDP.

    if (/\/products\//.test(location.href) && window.matchMedia("(max-width: ".concat(breakpoints.large, ")")).matches) {
      return;
    }

    if (window.zE) {
      window.zE('webWidget', 'updateSettings', {
        webWidget: {
          offset: {
            vertical: '0px',
            mobile: {
              vertical: '0px'
            }
          },
          zIndex: 23
        }
      });
    } else {
      window.zESettings = {
        webWidget: {
          offset: {
            vertical: '0px',
            mobile: {
              vertical: '0px'
            }
          },
          zIndex: 23
        }
      };
    }
  }
  /**
   * Expose public interface.
   */


  return Object.freeze({
    init
  });
});